<bl-modal-content #content
  [title]="'クーポン情報'"
  [footerButtonType]="modalButtonType.Custom"
>
  <div body>
    <bl-table
      [addClass]="'table-striped table-bordered table-hover'"
      [headers]="headers"
      [datas]="ticketIssueList"
      [maxHeight]="'calc(100vh - 350px)'"
      [displayEmptyMessage]="true"
      [selectable]="false"
      [nl2br]="true"
    ></bl-table>
  </div>
  <div footer>
    <button class="btn btn-success" type="button"
      (click)="content.cancel()">閉じる
    </button>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/page/profile-entries-page/reference-ticket-modal/reference-ticket-modal.component.html